var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{attrs:{"id":"add-surgery-file"}},[_c('button',{directives:[{name:"b-modal",rawName:"v-b-modal.surgery-files-modal",modifiers:{"surgery-files-modal":true}}]},[_c('Clip',{staticClass:"icon ml-1"})],1),_c('SurgeryFilesModal',{attrs:{"surgeryInformationId":_vm.surgeryId,"patientId":_vm.patientId},on:{"reload-files":_vm.onAttachFile}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }